<template>
  <div id="crypto">
    <vs-popup classContent="popup-example" v-if="popUps.popupAddActive" title="Confirm wallet" :active.sync="popUps.popupAddActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Wallet" v-model="formParams.cl_wallet" disabled/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Username" v-model="formParams.username" disabled/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Amount" v-model="formParams.amount" disabled/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Fee" v-model="formParams.fee"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Tx Id" v-model="formParams.tx_id"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData()" color="primary" type="filled">Save</vs-button>
        </div>
      </div>

    </vs-popup>
    <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :filters="filters"
      :form-params="formParams"
      :pop-ups="popUps"
      >
    </table-view>
  </div>
</template>

<script>

import tableView from '../../components/tableView';
import axios from "@/axios.js"
export default {
  components: {   
    tableView
  },
  data() {
    
    let data = {
      popUps:{popupAddActive:false},
      formParams:{},
      endPoint:'crypto',
      filters: {}
    }
    
    data.columnDefs= [
        {
          headerName: 'amount',
          field: 'amount',
          width: 125,
          filter: true,
        },
        {
          headerName: 'brand_wallet',
          field: 'brand_wallet',
          filter: true,
          width: 125,
        },
        {
          headerName: 'cl_wallet',
          field: 'cl_wallet',
          filter: true,
          width: 175,
        },
        {
          headerName: 'commi',
          field: 'commi',
          filter: true,
          width: 125,
        },
        {
          headerName: 'created_at',
          field: 'created_at',
          filter: true,
          width: 125,
        },
        {
          headerName: 'crypto_account',
          field: 'crypto_account',
          filter: true,
          width: 250,
        },
        {
          headerName: 'id',
          field: 'id',
          filter: true,
          width: 150,
        },
        {
          headerName: 'last_updated',
          field: 'last_updated',
          filter: true,
          width: 125,
        },
        {
          headerName: 'status',
          field: 'status',
          filter: true,
          width: 125,
        },
        {
          headerName: 'tran_id',
          field: 'tran_id',
          filter: true,
          width: 125,
        },
        {
          headerName: 'tx_id',
          field: 'tx_id',
          filter: true,
          width: 125,
        },
        {
          headerName: 'type',
          field: 'type',
          filter: true,
          width: 125,
        },
        {
          headerName: 'user_id',
          field: 'user_id',
          filter: true,
          width: 125,
        },
        {
          headerName: 'username',
          field: 'username',
          filter: true,
          width: 125,
        },        
        {
          headerName: 'Confirm',
          field:'confirm',
          action: 'confirmWallet',
          filter: false,
          cellStyle: {color: 'green'},
          cellRenderer: function() {
            return 'Confirm';
          }
        }       
      ]
    return data;
  },
  computed: {
  },
  methods:{
    sendData: function(){
        let that = this;                
        this.$vs.loading();
        axios.post("/api/crypto",this.formParams)
        .then((data) => {
          that.$vs.loading.close();                    
          const responseObj = JSON.parse(data.data[0].object);
          if(responseObj.result==='fail!')
            that.openAlert('danger','Failed',responseObj.output);
          else{
            that.popUps.popupAddActive=false
            that.formParams = {};
            that.openAlert('success','Success',responseObj.output);
          }
         })
      },
      openAlert(color,title,text) {
        let colorAlert = color;
        this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
        })
      }
  },
  mounted() {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
  }
}

</script>